import { render, staticRenderFns } from "./ImagePreviewButton.vue?vue&type=template&id=c24af2ea&scoped=true"
import script from "./ImagePreviewButton.vue?vue&type=script&lang=js"
export * from "./ImagePreviewButton.vue?vue&type=script&lang=js"
import style0 from "./ImagePreviewButton.vue?vue&type=style&index=0&id=c24af2ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24af2ea",
  null
  
)

export default component.exports